/**
 * Marks an hours figure that is the event's crew-call-to-end span rather than
 * an entry (see utils/assignmentHours.ts). One place for the wording.
 */

export const SCHEDULED_HOURS_TITLE = 'Scheduled hours (crew call to end time); none entered yet';

export default function ScheduledHoursBadge({ label = '(sched.)' }: { label?: string }) {
  return (
    <span className="ml-1 text-xs text-gray-400" title={SCHEDULED_HOURS_TITLE}>
      {label}
    </span>
  );
}
